import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appCurrencyInput]'
})
export class CurrencyInputDirective {

  private el: ElementRef;

  constructor(el: ElementRef) {
    this.el = el;
  }

  // Listen for the input event to also handle copy and paste.
  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.el.nativeElement.value = this.el.nativeElement.value.replace(/[^0-9]/g, '');
  }

}
